/** This export is automatically generated */
export const isoNow = '2025-06-27T11:25:29.472Z';
